
import galleryImg01 from '../../assets/images/gallery-01.jpg'
import galleryImg02 from '../../assets/images/gallery-02.jpg'
import galleryImg03 from '../../assets/images/gallery-03.jpg'
import galleryImg04 from '../../assets/images/gallery-04.jpg'
import galleryImg05 from '../../assets/images/gallery-05.jpg'
import galleryImg06 from '../../assets/images/gallery-06.jpg'
import galleryImg07 from '../../assets/images/gallery-07.jpg'
import galleryImg08 from '../../assets/images/gallery-08.jpg'
import galleryImg09 from '../../assets/images/gallery-09.jpg'
import galleryImg10 from '../../assets/images/gallery-10.jpg'

import galleryImg11 from '../../assets/images/gallery-11.jpg'

import galleryImg12 from '../../assets/images/gallery-12.jpg'



const galleryImages = [
    galleryImg01,
    galleryImg02,
    galleryImg03,
    galleryImg04,
    galleryImg05,
    galleryImg06,
    galleryImg07,
    galleryImg08,
    galleryImg09,
    galleryImg10,
    galleryImg11,
    galleryImg12
]
export default galleryImages